export const USER_VISIT_REQUEST = "USER_VISIT_REQUEST";
export const USER_VISIT_SUCCESS = "USER_VISIT_SUCCESS";
export const USER_VISIT_FAIL = "USER_VISIT_FAIL";

export const USER_QUOTE_REQUEST = "USER_QUOTE_REQUEST";
export const USER_QUOTE_SUCCESS = "USER_QUOTE_SUCCESS";
export const USER_QUOTE_FAIL = "USER_QUOTE_FAIL";